import React from 'react';
import { Field } from 'redux-form';
import { Typography, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Aux from '../../hoc/NoParent';
import PasswordInput from './PasswordInput';

const renderTextField = ({input, label, meta: {touched, error}, ...custom }) => {
    return (
        <Aux>
            <TextField 
                label={label} 
                error={touched && error !== undefined} 
                {...input} 
                {...custom} />
            { touched && error ? <Typography>{error}</Typography> : null }
        </Aux>
    );
}

const renderPasswordField = ({input, label, meta: {touched, error}, ...custom }) => {
    return (
        <Aux>
            <PasswordInput 
                label={label} 
                error={touched && error !== undefined} 
                {...input} 
                {...custom} />
            { touched && error ? <Typography>{error}</Typography> : null }
        </Aux>
    );
}

const renderHiddenField = ({input, label, meta: {touched, error}, ...custom }) => {
    return (
        <input type="hidden" {...input} />
    );
}

const styles = (theme) => {
    return {
        root: {
            paddingTop: theme.spacing(2), 
            paddingBottom: theme.spacing(1)
        }
    }
}

const input = (props) => {
    let renderType = renderTextField;

    switch(props.config.type) {
        case 'password':
            renderType = renderPasswordField;
            break;
        case 'hidden':
            renderType = renderHiddenField;
            break;
        default:
            renderType = renderTextField;
            break;
    }

    return (
        <Field 
            className={props.className}
            style={{width: '100%'}}
            component={renderType} 
            name={props.id} 
            {...props.config} />
    );
}

export default withStyles(styles)(input);